const {
  zipCodeRegexNumeric,
  onlyNumericNormalize,
  SPACE
} = require('../helpers');

exports.zipCodeNormalize = (zipCode) => onlyNumericNormalize(zipCode, 5);

exports.countryDefinition = {
  country: 'France',
  code: 'FR',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Street Address' },
    address2: { label: 'Street Address 2' },
    city: { label: 'Town', width: 0.5 },
    zipCode: {
      label: 'Postal Code',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  viewFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['zipCode', SPACE, 'city']
  ],
  formFormat: [['company'], ['address'], ['address2'], ['zipCode', 'city']],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(zipCodeRegexNumeric(5)),
      error: 'Must be 5 characters, 12345'
    }
  ]
};
